// Locale
export const LOCALE_SET = "LOCALE_SET";
// User authentication
export const AUTH_START = "AUTH_START";
export const AUTH_END = "AUTH_END";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_CLEAR = "AUTH_CLEAR";
export const SET_AUTH_ALERT = "SET_AUTH_ALERT";
export const CLEAR_AUTH_ALERT = "CLEAR_AUTH_ALERT";
// Password update/change
export const UPDATE_PASSWORD_START = "UPDATE_PASSWORD_START";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_FAIL = "UPDATE_PASSWORD_FAIL";
// Dictionary
export const DICTIONARY_START = "DICTIONARY_START";
export const DICTIONARY_END = "DICTIONARY_END";
export const DICTIONARY_SUCCESS = "DICTIONARY_SUCCESS";
export const DICTIONARY_FAIL = "DICTIONARY_FAIL";
export const CREATED_DICTIONARY = "CREATED_DICTIONARY";
export const DICTIONARY_CLEAR = "DICTIONARY_CLEAR";
// Tests
export const TESTS_START = "TESTS_START";
export const TESTS_END = "TESTS_END";
export const TESTS_SUCCESS = "TESTS_SUCCESS";
export const TESTS_FAIL = "TESTS_FAIL";
export const TESTS_CLEAR = "TESTS_CLEAR";
export const ACTIVE_TEST_TAB = "ACTIVE_TEST_TAB";
export const TESTS_UPDATE_DATA = "TESTS_UPDATE_DATA";
export const TESTS_SET_DATA = "TESTS_SET_DATA";
// Store
export const STORE_START = "STORE_START";
export const STORE_END = "STORE_END";
export const STORE_SUCCESS = "STORE_SUCCESS";
export const STORE_FAIL = "STORE_FAIL";
export const STORE_CLEAR = "STORE_CLEAR";
export const STORE_SET_DATA = "STORE_SET_DATA";
export const STORE_UPDATE_DATA = "STORE_UPDATE_DATA";
export const STORE_GET_COMPLEATED_TESTS = "STORE_GET_COMPLEATED_TESTS";
export const SET_STORE_ALERT = "SET_STORE_ALERT";
export const CLEAR_STORE_ALERT = "CLEAR_STORE_ALERT";
